import { RouteNotFound } from "controls";
import matchRoute from "helpers/matchRoute";
import { useLocation } from "react-router-dom";

export default function RoutesSwitch({ rules }) {
  const location = useLocation();

  const rule = rules.find(({ route, exact = false }) =>
    matchRoute(location.pathname, route, { exact }),
  );

  if (!rule) return <RouteNotFound />;
  return <rule.Component />;
}
